module.exports = __webpack_public_path__ + "img/qr_code.fc30eddc.svg";